<template>
    <div class="ratio">
        <div class="image zoom cursor-pointer">
            <img @click.prevent="$watchUser('item', item)" 
                v-lazy="img.url"
                :key="img.url"
                :style="{'object-position': img.focalPoint ? img.focalPoint : '50% 0'}"
            />
            <div v-if="isVideo" class="has-video"></div>
        </div>
        <slot/>
    </div>
</template>

<script>
    export default {
        name: 'VImg',

        props: {
            img: {
                type: Object,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            isVideo: Boolean
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Image.vue